<template>
  <div class="kfc-wrap">
    <div class="bg-white">
      <!-- 公众号头部导航栏 -->
      <kfc-nav></kfc-nav>
    </div>
    <div class="body-content">
      <div class="content-wrapper">
        <div class="title-box">
          <img src="~@/assets/img/kfc/icon_succeed.png"/>
          <div class="title-wrap">
            <div class="title">授权成功</div>
            <div class="sm-title">恭喜您，成功绑定公众号</div>
          </div>
        </div>
        <div class="tip-info">请先联系客服启用平台状态，否则平台将无法正常使用</div>
        <div class="qrcode-box">
          <div class="qrcode-div">
            <img class="qrcode-img" src="~@/assets/img/kfc/service1.jpg" alt="">
            <div class="nickname">守兔票务-雪糕</div>
          </div>
          <div class="qrcode-div">
            <img class="qrcode-img" src="~@/assets/img/kfc/service2.jpg" alt="">
            <div class="nickname">守兔票务-婷欧尼</div>
          </div>
        </div>
        <div class="back-btn" @click="backPlatform">返回平台</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPlatformUuidKfc } from '@/utils/auth.js'
import KfcNav from '@/components/KfcNav.vue'
export default {
  name: "Index",
  components: {
    KfcNav
  },
  data(){
    return{
      platformUuid: getPlatformUuidKfc()
    }
  },
  methods: {
    backPlatform(){
      this.$router.push({ path:'/pc/kfc/statistics' });
      // 快照id
      this.$router.push({
        path: '/pc/kfc/statistics',
        query: { platformUuid: this.platformUuid}
      })
    }
  }
}
</script>

<style scoped>
.body-content {
  padding: 0 260px;
  background: #f5f5fa;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: calc(100% - 80px);
}
@media screen and (max-width: 1750px) {
  .body-content {
    padding: 0 60px !important;
  }
}

.content-wrapper {
  background: #fff;
  margin: 20px auto 50px;
  border-radius: 8px;
  width: 72.916666%;
  text-align: center;
}
.bg-white {
  width: 100%;
  background: #fff;
}
.title-box{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 120px auto 50px;
}
.title-box img{
  width: 60px;
}
.title-box .title-wrap{
  margin-left: 20px;
  display: flex;
  flex-direction: column;
}
.title-box .title-wrap .title{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 24px;
  color: #222222;
}
.title-box .title-wrap .sm-title{
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #666666;
}
.tip-info{
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #222222;
}
.qrcode-box{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
}
.qrcode-box .qrcode-div{
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  width: 180px;
  padding: 20px;
}
.qrcode-box .qrcode-div:first-child{
  margin-right: 20px;
}
.qrcode-box .qrcode-div .qrcode-img{
  width: 140px;
  height: 140px;
  object-fit: contain;
}
.qrcode-box .qrcode-div .nickname{
  padding-top:10px;
  text-align: center;
  font-size: 16px;
  color: #222222;
}
.back-btn{
  margin: 60px auto;
  width: 180px;
  height: 36px;
  line-height: 36px;
  background: #D63036;
  border-radius: 2px;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/authsuccess/Index.vue